<template>
  <div class="people-desp" :class="{'limit': contentLineOverLimit && showMore}">
    <span v-html="despContent" />
    <div v-if="contentLineOverLimit" class="expand-more">
      <a v-if="showMore" herf="#" @click="showMore=false">
        <i class="material-icons icon">
          expand_more
        </i>
      </a>
      <a v-else herf="#" @click="showMore=true">
        <i class="material-icons icon">
          expand_less
        </i>
      </a>
    </div>
    <!-- <a v-if="(clientWidth < 768) && showMore" herf="#" @click="showMore=false">
      更多
    </a> -->
  </div>
</template>

<script>
export default {
  name: 'PeopleDesp',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showMore: true
    }
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth
    },
    despContent: function () {
      return this.content
      // return ((this.clientWidth < 768) && this.showMore) ? this.ellipsisContent : this.content
    },
    ellipsisContent: function () {
      return this.content.slice(0, 160) + '...'
    },
    contentLineOverLimit: function () {
      return this.content.length > 160
    }
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.people-desp{
  position: relative;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.6;
  color: $grey-7d;
  margin-bottom: 36px;
  &.limit{
    @include ellipsis-with-lines(5);
    .expand-more{
      position: absolute;
      top: 80px;
    }
  }
  .expand-more{
    position: relative;
    display: block;
    width: 100%;
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), #ffffff);
    text-align: center;
  }
  a{
    position: relative;
    display: inline-block;
    color: $link-hover;
    cursor: pointer;
    margin-top: 20px;
  }
}

@media only screen and (max-width: 767.98px) {
  .people-desp{
    color: $grey-9b;
    margin-top: 24px;
    margin-bottom: 24px;
  }
}
</style>
